import React, { useEffect, useState } from 'react';
import '../styles/ModalRegistraLancamento.css';
import Toast from '../components/Toast';

const ModalRegistraLancamento = ({ isOpen, onClose, onSubmit }) => {
    const [valor, setValor] = useState('');
    const [toast, setToast] = useState({ message: '', type: '' });

    useEffect(() => {
        if (toast.message) {
            const timer = setTimeout(() => setToast({ message: '', type: '' }), 3000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    if (!isOpen) return null;

    const handleValorChange = (e) => {
        const valorFormatado = e.target.value.replace(',', '.');
        setValor(valorFormatado);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = e.target.elements;

        if (!formData.descricao.value.trim() || !formData.valor.value.trim()) {
            setToast({ message: 'Por favor, preencha todos os campos.', type: 'error' });
            return;
        }

        onSubmit(formData); // Envia os dados
        setToast({ message: 'Lançamento registrado com sucesso!', type: 'success' });
        setValor(''); // Limpa o valor
    };

    return (
        <div className="modal-overlay-lancto">
            <div className="modal-content-lancto">
                <div className="modal-header">
                    <h2>Registrar Lançamento</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Descrição:</label>
                        <input type="text" name="descricao" required />
                    </div>
                    <div className="form-group">
                        <label>Valor:</label>
                        <input
                            type="text"
                            name="valor"
                            required
                            value={valor}
                            onChange={handleValorChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Tipo de Lançamento:</label>
                        <select name="tipo" required>
                            <option value="credito">Crédito</option>
                            <option value="debito">Débito</option>
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button className="button-primary" type="submit">Registrar</button>
                        <button className="button-secondary" type="button" onClick={onClose}>
                            Fechar
                        </button>
                    </div>
                </form>
                {toast.message && <Toast message={toast.message} type={toast.type} />}
            </div>
        </div>
    );
};

export default ModalRegistraLancamento;
